import { createSlice } from "@reduxjs/toolkit";

export const uiDetailsConsoleMenuSlice = createSlice({
    name: "UI_Details_console_menu",
    initialState: {
        isVisible: false,
        messaggio: ""    
    },
    reducers: {
        showConsole: (state) => {
            state.isVisible = true;         
        },
        hideConsole: (state) => {
            state.larghezza = false;           
        },
        showMessage: (state, action) => {
            state.messaggio = action.payload;
            if (!state.isVisible) {
                state.isVisible = true;       
            }
        },
        deleteMessage: (state) => {
            state.messaggio = "";
            if (state.isVisible) {
                state.isVisible = false;       
            }
        }
    }
});

export const { showConsole, hideConsole, showMessage, deleteMessage } = uiDetailsConsoleMenuSlice.actions;

export default uiDetailsConsoleMenuSlice.reducer;